import { Dialog, DialogContent, Typography, Box, Button } from "@mui/material";
import * as constants from "../../../constants";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";

const PassReqDialog = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation("Account");

  const dialogStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    bgcolor: "background.paper",
    p: 4,
  };
  const checkStyle = {
    fontSize: "1rem",
    mr: ".5rem",
  };
  const buttonStyle = {
    width: "10rem",
  };
  const dialogTextStyle = {
    mb: "1rem",
  };
  const textStyle = {
    mb: "2rem",
  };
  const handleHelpClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <Dialog open={isOpen}>
      <DialogContent sx={dialogStyle}>
        <Typography sx={textStyle} variant="h3">
          {t("passwordMustContain")}
        </Typography>
        <Box>
          <Typography sx={dialogTextStyle} variant="body1">
            <CheckCircleOutlineIcon sx={checkStyle} />
            {t("minimumCharacters", { count: constants.PASSWORD_MIN_LENGTH })}
          </Typography>
          <Typography sx={dialogTextStyle} variant="body1">
            <CheckCircleOutlineIcon sx={checkStyle} />
            {t("mustContainUpperLower")}
          </Typography>
          <Typography sx={dialogTextStyle} variant="body1">
            <CheckCircleOutlineIcon sx={checkStyle} />
            {t("mustIncludeNumber")}
          </Typography>
          <Typography sx={dialogTextStyle} variant="body1">
            <CheckCircleOutlineIcon sx={checkStyle} />
            {t("mustIncludeSymbol")}
          </Typography>
        </Box>
        <Button
          sx={buttonStyle}
          variant="contained"
          color="info"
          onClick={handleHelpClick}
        >
          {t("ok")}
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default PassReqDialog;
